module.exports = __webpack_public_path__ + "img/心碎.9c2b488d.gif";